import React from 'react';
import { useDebriefDispatch, useDebriefSelector } from 'ff/debrief/hooks';

import { ModalName } from 'ff/debrief/models';
import { closeModal, openModal } from 'ff/debrief/features/ModalSlice';

export const useDebriefModal = (modal: ModalName) => {
    const dispatch = useDebriefDispatch();
    const modalState = useDebriefSelector(s => s.modalSlice.modals[modal]);

    const open = React.useCallback(() => {
        dispatch(openModal(modal));
    }, [modal]);
    const close = React.useCallback(() => {
        dispatch(closeModal(modal));
    }, [modal]);
    const toggle = React.useCallback(() => {
        if (modalState) {
            open();
        } else {
            close();
        }
    }, [open, close]);

    return { isOpen: modalState, open, close, toggle };
};
